import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
const InputField = ({ type, className = "", noteText = "", name, Id, placeholder, label, onChange, value, onKeyDown, disabled, checked, onClick, testid, autoComplete, maxLength, isRequired = false,

    showErrorMessage

}: any) => {
    return (
        <FormGroup>
            <Label for={Id}>{label}{isRequired && <span className='text-danger'>*</span>}</Label>
            {noteText && <span className="note-text-color">{noteText}</span>}
            <Input
                className={className}
                type={type}
                name={name}
                id={Id}
                checked={checked}
                onClick={onClick}
                placeholder={placeholder}
                disabled={disabled}
                data-testid={testid}
                onChange={onChange}
                value={value}
                onKeyDown={onKeyDown}
                autoComplete={autoComplete}
                maxLength={maxLength}
                invalid={!!showErrorMessage}
            />
            {showErrorMessage && (
                <FormFeedback>
                    {showErrorMessage}
                </FormFeedback>
            )}

        </FormGroup>
    )
}
InputField.defaultProps = {
    disabled: false,
}
export default InputField